import { render, staticRenderFns } from "./add.vue?vue&type=template&id=8b3a5f3e&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b3a5f3e')) {
      api.createRecord('8b3a5f3e', component.options)
    } else {
      api.reload('8b3a5f3e', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=8b3a5f3e&", function () {
      api.rerender('8b3a5f3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/system-manage/account-manage/add.vue"
export default component.exports